import { SplitText } from '../vendor/gsap/SplitText';

function flatten(elements) {
    return elements.reduce((result, item) => {
        if (!['ul', 'ol'].includes(item.tagName.toLowerCase())) {
            result.push(item);
            return result;
        }
        const tempResult = flatten([...item.children]);
        result.push(...tempResult);
        return result;
    }, []);
}

const lineByLineAnimation = (element, timeline, position = '+=0') => {
    const childElementsCount = [...element.children]
        .filter((child) => child.tagName.toLowerCase() !== 'br')
        .length;
    const elementsToSplit = childElementsCount === 0 ? [element] : [...element.children];

    const split = new SplitText(flatten(elementsToSplit), { type: 'lines', linesClass: 'animation-line-container' });
    const animationLines = [];
    split.lines.forEach((line) => {
        const textWrap = document.createElement('div');
        textWrap.classList.add('animation-line');
        textWrap.innerHTML = line.innerHTML;
        line.innerHTML = '';
        line.appendChild(textWrap);
        animationLines.push(textWrap);
    });
    timeline.from(animationLines, {
        yPercent: 100,
        duration: 0.7,
        stagger: 0.1,
        ease: 'ease-out',
    }, position);
    return () => split.revert();
};

export default lineByLineAnimation;
